import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/personaFi/agent")({
  beforeLoad: () => {
    throw redirect({ to: "/agent", replace: true });
  },
});
